export default "## Thank you for submitting your information\n\nWe’ve received your details and will begin assessing your car.\n";